import styled from 'styled-components';

export const PagesHeader = styled.h1`
  margin-left: 20px;
  font-size: 20px;
`;

export const PagesParagraph = styled.p`
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 8px;
  margin-top: 8px;
  font-size: 15px;
  color: darkred;
`;

export const PagesBlock = styled.div`
  height: 100vh;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 30px;
`;

export const PagesH2 = styled.h2`
  display: flex;
  justify-content: center;
`;

export const PagesH1 = styled.h1`
  font-size: 22px;
  margin-left: 18px;

  @media (max-width: 600px) {
    font-size: 18px;
    margin-left: 10px;
  }
`;
